import { render, staticRenderFns } from "./SurfInlineThreeImageText.vue?vue&type=template&id=508f85fc&scoped=true"
import script from "./SurfInlineThreeImageText.vue?vue&type=script&setup=true&lang=js"
export * from "./SurfInlineThreeImageText.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SurfInlineThreeImageText.vue?vue&type=style&index=0&id=508f85fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508f85fc",
  null
  
)

export default component.exports